import React, { useContext } from "react";
import CertificationToBeSignedDetails from "pages/certificationToBeSignedDetails/CertificationToBeSignedDetails";
import CertificationContext from "module/certification/context/CertificationContext";

const CertificationToBeSignedDetailsContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);

  return (
    <CertificationToBeSignedDetails
      {...{
        certificationId: entity.id,
      }}
    />
  );
};

export default React.memo(CertificationToBeSignedDetailsContainer);
